import React from 'react';
import { Link } from 'react-router-dom';

import Hamburger from './Hamburger';
import LanguageToggle from './LanguageToggle';
import ThemeToggle from './ThemeToggle';
import routes from '../../data/routes';
import { useLanguage } from '../LanguageContext';
import useLanguageRouting from '../useLanguageRouting';

// Websites Navbar, displays routes defined in 'src/data/routes'
const Navigation = () => {
  const { lang, t } = useLanguage();
  const { localize } = useLanguageRouting();
  const pathFor = (l) => localize(typeof l.path === 'function' ? l.path(lang) : l.path);

  return (
    <header id="header">
      <h1 className="index-link">
        {routes.filter((l) => l.index).map((l) => (
          <Link key={l.key} to={localize(l.path)}>{l.label}</Link>
        ))}
      </h1>
      <nav className="links">
        <ul>
          {routes.filter((l) => !l.index).map((l) => (
            <li key={l.key}>
              <Link to={pathFor(l)}>
                {t.nav[l.key]}
                {l.badge && <span className="nav-badge">{l.badge}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div className="header-toggle">
        <LanguageToggle />
        <ThemeToggle />
      </div>
      <Hamburger />
    </header>
  );
};

export default Navigation;
